























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isDocumentFile, isImageFile, isTextFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import { MAIN_CONTAINER_WIDTH } from "@/const";
import BaseDownloadButton from "@/components/BaseDownloadButton";
import BaseImage from "@/components/BaseImage";
import DocumentAttachmentPreview from "@/components/DocumentAttachmentPreview";
import { pauseGlobalPlayer } from "@/components/GlobalAudioPlayer/helpers";
import PlayButton from "@/components/PlayButton";
import StereoVideo from "@/components/StereoVideo";
import UserWatermarkOverlay from "@/components/UserWatermarkOverlay";

export default defineComponent({
  name: "ContentFeedGalleryItem",
  components: {
    DocumentAttachmentPreview,
    StereoVideo,
    PlayButton,
    BaseImage,
    BaseDownloadButton,
    UserWatermarkOverlay,
  },
  props: {
    file: { type: Object as () => ContentFile, required: true },
    clicked: { type: Boolean, required: true },
    activeFileId: { required: true, type: String },
    isFullScreen: { type: Boolean, default: false },
    videoStartTime: { type: Number, default: 0 },
    videoAutoPlay: { type: Boolean, default: false },
    accessed: { type: Boolean, default: false },
    blur: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const dpr = Math.floor(window.devicePixelRatio);
    const videoElement = ref();
    const contentHidden = ref(false);
    const active = computed(() => props.activeFileId === props.file.id && props.clicked);
    const isVideo = computed(() => isVideoFile(props.file));
    const isImage = computed(() => isImageFile(props.file));
    const isDocument = computed(() => isDocumentFile(props.file) || isTextFile(props.file));

    const isPlayableVideo = computed(
      () => isVideo.value && ["NEW", "CONVERTING"].indexOf(props.file.processingStatus) === -1
    );
    const canDownloadFiles = computed(() => config.featureDownload && props.accessed);
    const videoSrc = computed(() => MediaFilesController.getVideoUrl(props.file.urlPart));
    const previewSrc = computed(() => {
      if (isVideo.value)
        return MediaFilesController.getVideoThumbnail(props.file.urlPart, MAIN_CONTAINER_WIDTH * dpr, 0, {
          exactSize: true,
        });
      if (isImage.value)
        return MediaFilesController.getImageThumbnail(props.file.urlPart, MAIN_CONTAINER_WIDTH * dpr, 0, {
          exactSize: true,
        });
      return `/img/content-no-preview.svg`;
    });
    const fullScreenImageSrc = computed(() => {
      if (window.innerHeight <= MAIN_CONTAINER_WIDTH) return previewSrc.value;
      if (isVideo.value) return MediaFilesController.getVideoThumbnail(props.file.urlPart, "1080p");
      if (isImage.value) return MediaFilesController.getImageThumbnail(props.file.urlPart, "1080p");
      return `/img/content-no-preview.svg`;
    });

    const imageSrc = computed(() => (props.isFullScreen ? fullScreenImageSrc.value : previewSrc.value));
    const fileUrl = computed(() => MediaFilesController.getFileUrl(props.file.urlPart));

    const click = () => {
      if (isVideo.value && props.accessed) {
        pauseGlobalPlayer();
        return emit("play");
      }
      emit("click");
    };

    const onWatermarkTamper = () => {
      contentHidden.value = true;
    };

    return {
      active,
      isPlayableVideo,
      videoSrc,
      imageSrc,
      previewSrc,
      fileUrl,
      canDownloadFiles,
      click,
      videoElement,
      isDocument,
      isVideo,
      isImage,
      contentHidden,
      onWatermarkTamper,
    };
  },
});
